module.exports = __webpack_public_path__ + "static/media/office1.b0e5e298.jpg";